import { ALLOWED_MAIL_DOMAIN_NAME_LIST } from "./constants/allowedMailDomainNameList";

type IsAllowedByEmail = (email: string) => boolean;

export const isAllowedByEmail: IsAllowedByEmail = (email) => {
  // 大文字が使える環境か向けに小文字で統一
  const normalizedEmail = email.toLowerCase();
  return ALLOWED_MAIL_DOMAIN_NAME_LIST.some((domainName) =>
    normalizedEmail.endsWith(domainName)
  );
};
